import { EDocTimestampStatus } from '@/context/services/invoice/type';
import { FC, PropsWithChildren, createContext, useContext } from 'react';

const Context = createContext<EDocTimestampStatus | undefined>(undefined);

type Props = {
  value: EDocTimestampStatus | undefined;
};

export const TimestampStatusProvider: FC<PropsWithChildren<Props>> = ({
  value,
  children,
}) => {
  return <Context.Provider value={value}>{children}</Context.Provider>;
};

export const useTimestampStatusChecker = () => {
  const value = useContext(Context);
  const checker = {
    // Timestamp processing
    isCreating: value === EDocTimestampStatus.creating,
    // Timestamp completed
    isDone: value === EDocTimestampStatus.done,
    // Timestamp needs retry
    isNeedRetry: value === EDocTimestampStatus.need_retry,
    // Timestamp failed
    isFailed: value === EDocTimestampStatus.failed,
    // Timestamp not supported
    isUnsupported: value === EDocTimestampStatus.unsupported,
  };
  return checker;
};

export const useTimestampStatus = () => {
  return useContext(Context);
};
